import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription, forkJoin } from 'rxjs';
// rxjs
import { Subject } from 'rxjs';
// import 'rxjs/add/operator/catch';
import { take, catchError } from 'rxjs/operators';


// services
import { ErrorHandler } from './error-handler.service';
import { DataStorageService } from './data-storage.service';
import { AppLoaderService } from '../../shared/services/app-loader.service';
// models
import { FlightFinderRequest } from '../models/flight-finder.interface';
import { FlightAPIRequest } from '../../booking/models/flight-request.interface';
import { AppState } from '../../booking/models/app-state.interface';
import { TimeslotAvailability } from '../../booking/models/timeslot-availability-request.interface';
import { SharedService } from './shared-service.service';
// path globals
import { API_PATH, SUBSCRIPTION_KEY, GET_FLIGHT_CONNECTIONS, GET_COVERAGE_MAP, FLIGHT_STATS, TIMESLOT_AVAILABILITY, ABC_PARTNERS, GET_PROMO_ID, SLOT_NUMBER } from '../globals';
import { isPlatformServer } from '@angular/common';
import { BagItemsService } from './bagItems.service';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

declare var ga: any;
declare var exponea: any;
const EXTERNAL_SESSION_REQUEST_KEY = makeStateKey('external_session_request');
@Injectable({
  providedIn: 'root',
})
export class FlightDetailsService {

  private _dataSavedSubscription: Subscription;
  private _flightStatsSubscription: Subscription;
  private _flightConnectionsSubscription: Subscription;
  private _ukAirports = ['LHR', 'LGW', 'LCY', 'LTN', 'STN', 'MAN'];
  private _swissAirports = ['GVA', 'ZRH'];
  private _ireLand = ['DUB'];
  private _austria = ['VIE'];
  private _germany = ['FRA'];
  private _directionChanged = false;

  public flightResults$: Subject<any> = new Subject();
  public selectedFlightData$: Subject<any> = new Subject();
  public showFlightSearch$: Subject<any> = new Subject();
  public getFlightStatus$: Subject<any> = new Subject();

  constructor(
    private _http: HttpClient,
    private _errorService: ErrorHandler,
    private _appStore: Store<AppState>,
    private _router: Router,
    private _dataStorageService: DataStorageService,
    private _appLoaderService: AppLoaderService,
    private _activatedRoute: ActivatedRoute,
    private _sharedService: SharedService,
    private _serverState: TransferState,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _bagItemsService: BagItemsService,
  ) { }

  getFlightData(request: FlightFinderRequest, hasSession?) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
      .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    if (this._flightConnectionsSubscription) { this._flightConnectionsSubscription.unsubscribe(); }
    this._flightConnectionsSubscription = this._http
      .post(API_PATH + GET_FLIGHT_CONNECTIONS, request, { headers: headers })
      .subscribe(
        (res: any) => {
          // this.flightResults$.next(res);
          // if plateform is server
          const regex = /^[0-9]+$/;
          if (isPlatformServer(this.platformId) && !regex.test(request.flightNumber)) {
            console.log(request, 'FLIGHT_REQUEST_AAA');
            const dep = res.flightConnections[0].flightStatusDetails[0].departureAirport;
            const arr = res.flightConnections[0].flightStatusDetails[0].arrivalAirport;
            const externalSessionRequest = {
              departureAirport: dep.airportCode,
              fromAirport: dep.airportName,
              fromCity: dep.airportCityName,
              toAirport: arr.airportName,
              toCity: arr.airportCityName,
              arrivalAirport: arr.airportCode,
              airline: res.flightConnections[0].flightStatusDetails[0].airlineCode,
              airlineName: res.flightConnections[0].flightStatusDetails[res.flightConnections[0].flightStatusDetails.length - 1].airlineName,
              departDate: request.flightDateTime,
              bagCount: 1,
              bagItems: this._bagItemsService.BagsClassificationToBagItems([
                {
                  "type": 1,
                  "count": 1
                },
                {
                  "type": 2,
                  "count": 0
                },
                {
                  "type": 3,
                  "count": 0
                }
              ]),
              flightDirection: 1,
              flightNumber: request.flightNumber,
              optedInViaPod: false,
            };
            this._serverState.set(EXTERNAL_SESSION_REQUEST_KEY, externalSessionRequest as any);
            this._appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE_DATA', payload: externalSessionRequest });
          }

          this.flightResults$.next(res);
          setTimeout(() => {
            this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
          }, 0);
          if(request.numberOfLegs) {
            this._appStore.dispatch({ type: 'SET_REQUEST_LEGS', payload: request.numberOfLegs });
          }
        },
        err => {
          this.flightResults$.next(err);
          this._errorService.handleError(err);
          this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
          return;
        });

  };

  getFlightDataPromise(request: FlightFinderRequest, hasSession?) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
      .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    const promise = new Promise((resolve, reject) => {
      this._http
      .post(API_PATH + GET_FLIGHT_CONNECTIONS, request, { headers: headers })
      .toPromise()
        .then((res: any) => {
          resolve(res);
          // we always call with 3 numberOfLegs to get correct multi leg data link final
          // leg information
          if (res.flightConnections.length === 0 && request.numberOfLegs === 3) {
            return;
          }
          this.flightResults$.next(res);
          if (request.numberOfLegs) {
            this._appStore.dispatch({ type: 'SET_REQUEST_LEGS', payload: request.numberOfLegs });
          }
      })
      .catch(err => {
        this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
        reject(err);
        return;
      });
    })

    return promise;
  };

  getZonePrice(request: any) {

    const headers = new HttpHeaders()
      .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    // const request ={
    //   airlineCode: airlineCode,
    //   departureAirportCode: departureAirportCode,
    //   airportCode: airportCode,
    //   journeyDirection: journeyDirection,
    //   numberOfBags: bags
    // };

    request.slotNumber =  this._sharedService.getCurrentSlotNumber();

    return this._http
      .post(API_PATH + GET_COVERAGE_MAP, request, { headers: headers })

  }

  getPromoById(promoId) {
    const request = {
      promotionId: promoId
    };

    const headers = new HttpHeaders()
      .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    return this._http.post(API_PATH + GET_PROMO_ID, request, { headers:headers });
  }

  getDiscountedPrice(price, promoAmount, promoType) {
    // 1=fixed; 2=percentage
    let discountAmount
    if (promoType === 2) {
      const discount = Math.ceil(promoAmount * price / 100);
      discountAmount = price - discount > 0 ? price - discount : 0;
    } else {
      const discountedPrice = price - (promoAmount / 100);
      discountAmount = discountedPrice > 0 ? discountedPrice : 0;
    }
    return Number.parseFloat(discountAmount.toFixed(2));
  }

  setInitialBookingPrice(outboundPrice?, inboundPrice?, promo?) {
    let priceData:any = {};
    let totalPrice = outboundPrice && inboundPrice ? outboundPrice.zoneValuePriceMajor + inboundPrice.zoneValuePriceMajor : outboundPrice ? outboundPrice.zoneValuePriceMajor : inboundPrice.zoneValuePriceMajor;
    let deppPrice = outboundPrice && outboundPrice.zoneValuePriceMajor;
    let minOutboundPrice = 0;
    // const additionalBagsPrice = outboundPrice ? outboundPrice.additionalBagPriceMajor : inboundPrice.additionalBagPriceMajor;
    if (outboundPrice) {
      minOutboundPrice = outboundPrice.postOfficePriceMajor === 0 ? outboundPrice.zoneValuePriceMajor : Math.min(outboundPrice.zoneValuePriceMajor, outboundPrice.postOfficePriceMajor);
    }
    let deppPostOfficePrice = outboundPrice && outboundPrice.currency + outboundPrice.postOfficePriceMajor;
    let arrPrice = inboundPrice && inboundPrice.zoneValuePriceMajor
    const currency = outboundPrice ? outboundPrice.currency : inboundPrice.currency;

    if(outboundPrice){
      this._appStore.dispatch({ type: 'SAVE_OUTBOUND_ADDITIONAL_BAG_PRICE', payload: outboundPrice.currency + outboundPrice.additionalBagPriceMajor  });
    }

    if(inboundPrice){
      this._appStore.dispatch({ type: 'SAVE_INBOUND_ADDITIONAL_BAG_PRICE', payload: inboundPrice.currency + inboundPrice.additionalBagPriceMajor });
    }

    if (promo?.promotion) {
      const { promotion } = promo;
      const promoCurrency = promotion.message.includes('£') ? '£' : promotion.message.includes('CHF') ? 'CHF' : '%';

      if (currency === promoCurrency || promoCurrency === '%'){
        if (outboundPrice?.zoneValuePriceMajor) {
          deppPrice = this.getDiscountedPrice(outboundPrice.zoneValuePriceMajor, promotion.rewardAmount, promotion.rewardType);
          deppPostOfficePrice = outboundPrice.currency + this.getDiscountedPrice(outboundPrice.postOfficePriceMajor, promotion.rewardAmount, promotion.rewardType);
        }
        if (inboundPrice?.zoneValuePriceMajor) { arrPrice = this.getDiscountedPrice(inboundPrice.zoneValuePriceMajor, promotion.rewardAmount, promotion.rewardType); }
        totalPrice = this.getDiscountedPrice(totalPrice, promotion.rewardAmount, promotion.rewardType)
      }
    }

    if (outboundPrice && inboundPrice) {
      priceData = {
        departurePrice: outboundPrice.currency + deppPrice,
        arrivalPrice: inboundPrice.currency + arrPrice,
        d2dPrice: outboundPrice.currency + totalPrice
      }

      this._appStore.dispatch({ type: 'SAVE_OUT_BOUND_PRICE', payload: priceData.departurePrice });
      this._appStore.dispatch({ type: 'SAVE_IN_BOUND_PRICE', payload: priceData.arrivalPrice });
      this._appStore.dispatch({ type: 'SAVE_POST_OFFICE_PRICE', payload: deppPostOfficePrice });

      this._appStore.dispatch({
        type: 'SET_FLYBACK_MIN_PRICE', payload: {
          outboundPrice: priceData.departurePrice,
          inboundPrice: priceData.arrivalPrice,
          departurePostOfficePrice: deppPostOfficePrice
        }
      });

    } else if (outboundPrice) {
      priceData = {
        departurePrice: outboundPrice.currency + totalPrice,
        d2dPrice: outboundPrice.currency + totalPrice
      }

      this._appStore.dispatch({ type: 'SAVE_OUT_BOUND_PRICE', payload: priceData.departurePrice });
      this._appStore.dispatch({ type: 'SAVE_POST_OFFICE_PRICE', payload: deppPostOfficePrice });


      this._appStore.dispatch({
        type: 'SET_FLYBACK_MIN_PRICE', payload: {
          outboundPrice: priceData.departurePrice,
          departurePostOfficePrice: deppPostOfficePrice
        }
      });

    } else if (inboundPrice) {
      priceData = {
        arrivalPrice: inboundPrice.currency + totalPrice,
        d2dPrice: inboundPrice.currency + totalPrice
      }

      this._appStore.dispatch({ type: 'SAVE_IN_BOUND_PRICE', payload: priceData.arrivalPrice });

      this._appStore.dispatch({
        type: 'SET_FLYBACK_MIN_PRICE', payload: {
          inboundPrice: priceData.arrivalPrice,
        }
      });

    }

    return priceData;
  }

  getFlightStatsData(multiLegData, request: FlightAPIRequest, hasFlightSession, directionChanged: boolean, isLinkedConnection?: boolean, serviceTypeSelected?: boolean, _productAvailability?: any, sessionData?: any, responseData?: any, flyback = false) {
    console.log(multiLegData, request, hasFlightSession, directionChanged, isLinkedConnection, 'getflightStatsData');

    this._directionChanged = directionChanged;

    const rqs = JSON.parse(JSON.stringify(request));
    rqs.firstLeg.flightNumber = request.firstLeg.flightNumber.trim();
    request = rqs;
    const isMultiLegCCD = request?.lastLeg?.flightDirection === 2 && request?.lastLeg?.isPrimary;

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
      .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    request.slotNumber =  this._sharedService.getCurrentSlotNumber();

    this._flightStatsSubscription = this._http
    .post(API_PATH + FLIGHT_STATS, request, { headers: headers })
      .subscribe((res: any) => {
        this.handleResponse(multiLegData, request, hasFlightSession, res, isLinkedConnection, serviceTypeSelected, _productAvailability, sessionData, flyback);
      },
      err => {
        this._errorService.handleError(err);
        this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
        this._appStore.dispatch({ type: 'UPDATE_DATALINK_ERROR', payload: true });
        this._appStore.dispatch({ type: 'SET_REQUEST_COUNT', payload: 0 });
        this._flightStatsSubscription.unsubscribe();
      });

  }

  handleResponse(multiLegData, request: FlightAPIRequest, hasFlightSession, res, isLinkedConnection?: boolean, serviceTypeSelected?: boolean, _productAvailability?: any, sessionData?: any, flyback = false) {
    if (res.validationErrors.length > 0) {
      this._errorService.handleError(res);
      this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
      this._appStore.dispatch({ type: 'UPDATE_DATALINK_ERROR', payload: true });
      this._flightStatsSubscription.unsubscribe();
      return;
    }

    if(hasFlightSession && sessionData) {
      const productAvailability = {
        abc: res.productAvailability.abcAvailable,
        ccd: res.productAvailability.ccdAvailable,
        sds: res.productAvailability.sdsAvailable,
        isDomesticABC: res.productAvailability.isDomesticABC
      }
      this._appStore.dispatch({ type: 'UPDATE_AVAILABLE_PRODUCTS', payload: productAvailability });
      this._appStore.dispatch({ type: 'UPDATE_SESSION_REQUEST', payload: { hasSession: true, request: request }});
      if (this.getState(this._appStore).d2dReducer.userSelectedServicetype === 'd2d') {
        this._appStore.dispatch({ type: 'UPDATE_D2D_SERVICE', payload: true });
      }
    }
    const currentState = this.getState(this._appStore);
    const flightFinderData = currentState.flightFinderReducer.quoteFlightRequest;
    const getZonePriceRequestOutbound = {
      airlineCode: flightFinderData.airline,
      departureAirportCode: flightFinderData.departureAirport,
      airportCode: flightFinderData.departureAirport,
      journeyDirection: 1,
      numberOfBags: flightFinderData.bagCount
    };

    const getZonePriceRequestInbound = {
      airlineCode: flightFinderData.airline,
      departureAirportCode: flightFinderData.departureAirport,
      airportCode: flightFinderData.arrivalAirport,
      journeyDirection: 2,
      numberOfBags: flightFinderData.bagCount
    };
    const qParams = this._activatedRoute.snapshot.queryParams;
    if (hasFlightSession && sessionData) {
      const data = JSON.parse(sessionData.earliestFlight)
      getZonePriceRequestOutbound.airlineCode = data.OperatingCarrier;
      getZonePriceRequestOutbound.airportCode = data.DepartureAirportCode;
      getZonePriceRequestOutbound.departureAirportCode = data.DepartureAirportCode;
      getZonePriceRequestOutbound.numberOfBags = sessionData.bagCount;

      getZonePriceRequestInbound.airlineCode = data.OperatingCarrier;
      getZonePriceRequestInbound.airportCode = qParams.lastLegArrivalAirportCode ? qParams.lastLegArrivalAirportCode.replaceAll('"', '') : data.ArrivalAirportCode;
      getZonePriceRequestInbound.departureAirportCode = data.DepartureAirportCode;
      getZonePriceRequestInbound.numberOfBags = sessionData.bagCount;
    }


    // check booking type
    // # if abc let it go
    // # if ccd/multi-leg need to modify request for setFlightStoreItems() and pass it to modal
    const multiLegData_ = JSON.parse(JSON.stringify(multiLegData));
    if (!res.productAvailability.abcAvailable && res.productAvailability.ccdAvailable) {
      res.flightDirection = 2;
      res.productAvailability = {
        ...res.productAvailability,
        abcAvailable: false,
        ccdAvailable: true,
        isDomesticABC: false,
        journeyDirection: 2,
      }

      if (multiLegData && multiLegData.totalNumberOfLegs > 1) {
        multiLegData_.flightInfo.requestFlightNumber = res.flightInfo.requestFlightNumber;
        multiLegData_.flightInfo.dateTimeAddedUTC = res.flightInfo.dateTimeAddedUTC;
        multiLegData_.flightInfo.requestedDateTime = res.flightInfo.requestedDateTime;
      }
    }
    // product type is not selected yet
    if (!serviceTypeSelected && currentState.bookingReducer.bookingDetails.bookingType === 'new') {
      let priceCalls = [];
      const promoFromUrl = this.getState(this._appStore).flightFinderReducer.promoFromUrl;
      if (promoFromUrl) {
        priceCalls = [this.getPromoById(promoFromUrl)];
      }
      if(flyback){
        // TODO:  only ccd for flyback
        priceCalls = [this.getZonePrice(getZonePriceRequestInbound),...priceCalls];
        forkJoin(priceCalls).subscribe((responses: any[]) => {
          const priceData = this.setInitialBookingPrice(null, responses[0], responses[1]);
          this.getFlightStatus$.next({ multiLegData: multiLegData_, res, priceData, hasFlightSession, isLinkedConnection });
        });

      } else if (res.productAvailability.abcAvailable && res.productAvailability.ccdAvailable) {
        // abc & ccd
        priceCalls = [this.getZonePrice(getZonePriceRequestOutbound), this.getZonePrice(getZonePriceRequestInbound),...priceCalls];
        forkJoin(priceCalls).subscribe((responses: any[]) => {
          const priceData = this.setInitialBookingPrice(responses[0], responses[1], responses[2]);
          this.getFlightStatus$.next({ multiLegData: multiLegData_, res, priceData, hasFlightSession, isLinkedConnection });
        });

      } else if (!res.productAvailability.abcAvailable && res.productAvailability.ccdAvailable) {
        // only ccd
        priceCalls = [this.getZonePrice(getZonePriceRequestInbound), ...priceCalls];
        forkJoin(priceCalls).subscribe((responses: any[]) => {
          const priceData = this.setInitialBookingPrice(null, responses[0], responses[1]);
          const showModel = this.getState(this._appStore).flightFinderReducer.selectedProductType !== '';

          if(showModel ){
            this.getFlightStatus$.next({ multiLegData: multiLegData_, res, priceData, hasFlightSession, isLinkedConnection });
          } else {
            this.setFlightStoreItems(multiLegData_, res, hasFlightSession, isLinkedConnection, _productAvailability, flyback);
          }
        });
      } else if (res.productAvailability.abcAvailable && !res.productAvailability.ccdAvailable) {
        // only abc
        priceCalls = [this.getZonePrice(getZonePriceRequestOutbound), ...priceCalls];
        forkJoin(priceCalls).subscribe((responses:any[]) => {
           const priceData = this.setInitialBookingPrice(responses[0], null, responses[1]);
           const showModel = this.getState(this._appStore).flightFinderReducer.selectedProductType !== '';

          if(showModel ){
            this.getFlightStatus$.next({ multiLegData: multiLegData_, res, priceData, hasFlightSession, isLinkedConnection });
          } else {
            this.setFlightStoreItems(multiLegData_, res, hasFlightSession, isLinkedConnection, _productAvailability, flyback);
          }
        });
      } else {
        this._appLoaderService.hideLoader();

        const errorData = {
          text: "Sorry, we don't service that flight - contact our support team for more info.",
          sticky: false
        };
        this._errorService.handleCustomError(errorData);
        this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
        // no service available
        const currentUrl = location.pathname;
        const flightStatusDetails = res.flightStatusDetails[0];
        exponea.track('cant_support_flight', {
          operated_airline_name: flightStatusDetails.operatingAirlineName,
          marketed_airline_name: flightStatusDetails.airlineName,
          flight_number: flightStatusDetails.flightNumber,
          operated_flight_number: flightStatusDetails.operatingFlightNumber,
          flight_date: flightStatusDetails.departureDateTimeDetails.scheduledDate,
          entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
        });
        exponea.track('airline_not_partner', { entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct', });
        ga('send', 'event', 'Error', 'This flight isn\'t eligible for AirPortr, so we\'re sad to say we can\'t help you this time.', currentUrl);
        // redirect to home page
        // window.location.replace(environment.homeURL);
      }
    } else {
      // update panelReducer
      // this._appStore.dispatch({ type: 'PANEL_RESET' });
      this.setFlightStoreItems(multiLegData_, res, hasFlightSession, isLinkedConnection, _productAvailability, flyback);
    }

    // if (res.productAvailability.abcAvailable && res.productAvailability.ccdAvailable) {

    //   // this.getFlightStatus$.next({ multiLegData, res, hasFlightSession, isLinkedConnection });

    // } else if (res.productAvailability.ccdAvailable) {
    //   const multiLegData_ = JSON.parse(JSON.stringify(multiLegData));
    //   res.flightDirection = 2;
    //   res.productAvailability = {
    //     ...res.productAvailability,
    //     abcAvailable: false,
    //     ccdAvailable: true,
    //     isDomesticABC: false,
    //     journeyDirection: 2,
    //   }

    //   if(multiLegData.totalNumberOfLegs > 1) {
    //     multiLegData_.flightInfo.requestFlightNumber = res.flightInfo.requestFlightNumber;
    //     multiLegData_.flightInfo.dateTimeAddedUTC = res.flightInfo.dateTimeAddedUTC;
    //     multiLegData_.flightInfo.requestedDateTime = res.flightInfo.requestedDateTime;
    //     // multiLegData_.flightStatusDetails = res.flightStatusDetails;
    //   }
    //   this.setFlightStoreItems(multiLegData_, res, hasFlightSession, isLinkedConnection);
    // } else {
    //   this.setFlightStoreItems(multiLegData, res, hasFlightSession, isLinkedConnection);
    // }
  }

  selectFlight(flight, flightDirection, _productAvailability) {

    let quoteFlightDirection;
    let isMultiLegFlight;

    quoteFlightDirection = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.flightDirection;
    if (flight.totalNumberOfLegs > 1 || flight.productAvailability === null) {
      isMultiLegFlight = true;
      this._appStore.dispatch({type: 'UPDATE_API_SEARCH', payload: true});
    }

    // this._appLoaderService.showLoader();
    this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: true });

    let request: FlightAPIRequest = {
      firstLeg: {
        flightNumber: flight.flightStatusDetails[0].airlineCode + flight.flightStatusDetails[0].flightNumber,
        flightDirection: flightDirection,
        departureDate: flightDirection == 1
        ? flight.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal
        : flight.flightStatusDetails[0].arrivalDateTimeDetails.scheduledDateTimeLocal,
        isPrimary: true
      }
    };

    if (isMultiLegFlight) {
      request.firstLeg.isPrimary = flight.flightStatusDetails[0].isPrimaryLeg;
      request.lastLeg = {
        flightNumber: flight.flightStatusDetails[flight.flightStatusDetails.length - 1].airlineCode + flight.flightStatusDetails[flight.flightStatusDetails.length - 1].flightNumber,
        flightDirection: flightDirection,
        departureDate: flightDirection == 1
          ? flight.flightStatusDetails[flight.flightStatusDetails.length - 1].departureDateTimeDetails.scheduledDateTimeLocal
          : flight.flightStatusDetails[flight.flightStatusDetails.length - 1].arrivalDateTimeDetails.scheduledDateTimeLocal,
        isPrimary: flight.flightStatusDetails[flight.flightStatusDetails.length - 1].isPrimaryLeg
      };
    }

    // updated for ccd/abc critical case
    if (isMultiLegFlight && flightDirection === 2) {
      request.firstLeg.isPrimary = false;
      request.lastLeg.isPrimary = true;
      request.lastLeg.flightDirection = 2;
    }

    if(isMultiLegFlight) {
      if(flight.flightDirection === 2) {
        request.firstLeg.flightDirection = 2;
        request.lastLeg.flightDirection = 2;
        request.firstLeg.isPrimary = false;
        request.lastLeg.isPrimary = true;
        this.getFlightStatsData(flight, request, false, false, undefined, true, _productAvailability);
      } else {
        this.setFlightStoreItems(flight, request, false, false, _productAvailability);
      }
    } else {
      this.setFlightStoreItems(flight, request, false, false, _productAvailability);
    }

    // no need to get flight stats if direct flight
    // this.getFlightStatsData(flight, request, false, false, undefined);
  }


  cancelFlightRequest() {
    if (this._flightConnectionsSubscription) {
      this._flightConnectionsSubscription.unsubscribe();
    }
  }

  //OBSOLETE
  checkDirection(code) {


    if (code === null || typeof code === 'undefined') { return null; }
    if (code.length === 0) { return null; }

    // if passed in code (which is the 'from' field) is equal to the London airport list
    // direction is 1 (outbound) else it's 2
    let result = 2;

    for (const airport of this._ukAirports) {
      if (airport.toLocaleUpperCase() === code.toLocaleUpperCase()) {
        result = 1;
      }
    }
    for (const airport of this._swissAirports) {
      if (airport.toLocaleUpperCase() === code.toLocaleUpperCase()) {
        result = 1;
      }
    }
    for (const airport of this._ireLand) {
      if (airport.toLocaleUpperCase() === code.toLocaleUpperCase()) {
        result = 1;
      }
    }
    for (const airport of this._austria) {
      if (airport.toLocaleUpperCase() === code.toLocaleUpperCase()) {
        result = 1;
      }
    }

    for (const airport of this._germany) {
      if (airport.toLocaleUpperCase() === code.toLocaleUpperCase()) {
        result = 1;
      }
    }

    return result;

  }

  setFlightStoreItems(data, flightStatsData, hasFlightSession, isLink?, _productAvailability?, flyback = false) {


    console.log(data, flightStatsData, hasFlightSession, isLink, 'setFlightStoreItems');
    // set the selected flight in addBooking
    // if multileg connection
    const state = this.getState(this._appStore);
    if (this.getState(this._appStore).flightFinderReducer.searchMultiLegApi) {
      if (isLink) {
        this._appStore.dispatch({ type: 'UPDATE_SELECTED_MULTILEG_FLIGHT', payload: data });
      } else {
        this._appStore.dispatch({ type: 'UPDATE_SELECTED_MULTILEG_FLIGHT', payload: data });
      }
    } else {
      this._appStore.dispatch({ type: 'UPDATE_SELECTED_MULTILEG_FLIGHT', payload: null });
    }

    if (hasFlightSession && data?.flightStatusDetails?.length > 1) {
      this._appStore.dispatch({ type: 'UPDATE_SELECTED_MULTILEG_FLIGHT', payload: data });
    }

    // if data comes from datalink or from flight number filter search
    // set data (multileg) to returned flightStatsData
    if (hasFlightSession || data === null) {
      const temp = JSON.parse(JSON.stringify(flightStatsData));
      if (data) {
        temp.flightStatusDetails = data.flightStatusDetails;
        temp.totalNumberOfLegs = data.flightStatusDetails.length;
      }

      data = temp;
    }

    if (data.primaryLeg === 0 || data.flightDirection === 0) {
      this.flightServiceError();
      return;
    }

    // if multi leg
    // use product availability and airport terminal from FlightStats
    if (flightStatsData !== null) {
      //data.productAvailability = flightStatsData.productAvailability;
      const obj = JSON.parse(JSON.stringify(data));
      obj.productAvailability = flightStatsData.productAvailability;
      data = obj;
      if (flightStatsData.productAvailability.journeyDirection === 1) {
        obj.flightStatusDetails[data.primaryLeg - 1].departureAirport.airportTerminal =
          flightStatsData.flightStatusDetails[0].departureAirport.airportTerminal;
        data = obj;
      } else {
        obj.flightDirection = 2;
        obj.flightStatusDetails[data.primaryLeg - 1].arrivalAirport.airportTerminal =
          flightStatsData.flightStatusDetails[flightStatsData.totalNumberOfLegs - 1].arrivalAirport.airportTerminal;
        data = obj;
      }
    }

    this._appStore.dispatch({ type: 'UPDATE_FLIGHT_RESPONSE', payload: data });

    let flightAvailability = { abc: null, ccd: null, sds: null, isDomesticABC: null };

    try {
      flightAvailability = {
        abc: data.productAvailability.abcAvailable,
        ccd: data.productAvailability.ccdAvailable,
        sds: data.productAvailability.sdsAvailable,
        isDomesticABC: data.productAvailability.isDomesticABC
      };
    } catch (error) {
      this.flightServiceError();
      return;
    }

    if (!flightAvailability.abc && !flightAvailability.sds && !flightAvailability.ccd) {
      this.flightServiceError();
      return;
    }

    const carrierItem = {
      originalAirlineCode: data.flightStatusDetails[0].airlineCode,
      airlineCodeDisplayName: data.flightStatusDetails[0].airlineCodeDisplayName,
      airlineCode: '',
      airlineName: data.flightStatusDetails[0].airlineName,
      operatingCode: data.flightStatusDetails[0].operatingAirlineCode,
      operatingName: data.flightStatusDetails[0].operatingAirlineName
    };

    if (ABC_PARTNERS.find(partner => partner.code === data.flightStatusDetails[0].airlineCode.toLocaleUpperCase())) {
      carrierItem.airlineCode = data.flightStatusDetails[0].airlineCode;
    } else {
      carrierItem.airlineCode = 'OTHER';
    }

    // set product in store

    // remove me

    // const quoteFlightDirection = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.flightDirection;
    // const journeyDirection = quoteFlightDirection ? quoteFlightDirection : data.productAvailability.journeyDirection;
    // let journeyType;
    // if (quoteFlightDirection) {
    //   journeyType = quoteFlightDirection === 1 ? 1 : 0;
    // } else {
    //   journeyType = data.productAvailability.abcAvailable === true ? 1 : 0;
    // }

    this._appStore.dispatch({
      type: 'UPDATE_JOURNEY_LEG', payload: {
        journeyId: 1,
        journeyType: data.productAvailability.abcAvailable === true ? 1 : 0,
        journeyDirection: data.productAvailability.journeyDirection
      }
    });
    this._appStore.dispatch({ type: 'UPDATE_BOOKING_PRODUCT', payload: data.productAvailability.abcAvailable === true ? 'abc' : 'ccd' });
    this._appStore.dispatch({ type: 'UPDATE_FLIGHT_PRODUCTS', payload: flightAvailability });

    if (!state.d2dReducer.hasSession) {
      if (_productAvailability) {
        const unTouchFlightAvailability = {
          abc: _productAvailability.abcAvailable,
          ccd: _productAvailability.ccdAvailable,
          sds: _productAvailability.sdsAvailable,
          isDomesticABC: _productAvailability.isDomesticABC
        }
        this._appStore.dispatch({ type: 'UPDATE_AVAILABLE_PRODUCTS', payload: unTouchFlightAvailability });
      } else {
        this._appStore.dispatch({ type: 'UPDATE_AVAILABLE_PRODUCTS', payload: flightAvailability });
      }
    }

    this._appStore.dispatch({ type: 'UPDATE_CARRIER', payload: carrierItem });
    this._appStore.dispatch({
      type: 'UPDATE_TIMESLOT', payload: {
        start: '',
        end: '',
        date: '',
        id: '',
        airportTimeslotsWarning: false
      }
    });
    const finalDestinationAirport = data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalAirport;
    const apiFinalDestination = {
      airportCode: finalDestinationAirport.airportCode,
      airportName: finalDestinationAirport.airportName,
      airportCityName: finalDestinationAirport.airportCityName,
      airportCountryName: finalDestinationAirport.airportCountryCode
    };

    const currentBooking = data.flightDirection === 1 ? 'abc' : 'ccd';
    const upsellBooking = data.flightDirection === 1 ? 'ccd' : 'abc';

    this._appStore.dispatch({ type: 'UPDATE_FINAL_DESTINATION', payload: apiFinalDestination });

    // check the timeslots...
    this.checkTimeslots(data).then((timeslotResponse: any) => {
      const state = this.getState(this._appStore);
      const availableProducts = state.d2dReducer.flightDetails.flightProducts;
      // if timeslot has an error
      this._appStore.dispatch({ type: 'SET_REQUEST_COUNT', payload: 0 });

      /**
       * @upsell
       * when timeslots for second booking are not available but first booking steps are complete then navigate
       * user to payment screen for first booking
       */
      if (!timeslotResponse.areTimeSlotsAvailable && currentBooking === 'abc' && state.d2dReducer.inboundBooking.isCompleted) {
        const productAvailability = JSON.parse(JSON.stringify(state.d2dReducer.flightDetails.flightProducts));
        productAvailability[currentBooking] = false;
        this._appStore.dispatch({ type: 'UPDATE_AVAILABLE_PRODUCTS', payload: productAvailability });
        this._appStore.dispatch({ type: 'UPDATE_ABC_TIMESLOT_STATUS', payload: false });
        this._appStore.dispatch({ type: 'UPSELL_BOOKING_STATUS', payload: {showUpsellScreen: true, currentBooking: currentBooking, upsellBooking: upsellBooking, upsellConverted: state.upsellBookingReducer.upsellConverted} });
        this.saveAndRedirect(flyback);
        return;
      } else if (!timeslotResponse.areTimeSlotsAvailable && currentBooking === 'ccd' && state.d2dReducer.outboundBooking.isCompleted) {
        const productAvailability = JSON.parse(JSON.stringify(state.d2dReducer.flightDetails.flightProducts));
        productAvailability[currentBooking] = false;
        this._appStore.dispatch({ type: 'UPDATE_AVAILABLE_PRODUCTS', payload: productAvailability });
        this._appStore.dispatch({ type: 'UPDATE_CCD_TIMESLOT_STATUS', payload: false });
        this._appStore.dispatch({ type: 'UPSELL_BOOKING_STATUS', payload: {showUpsellScreen: true, currentBooking: currentBooking, upsellBooking: upsellBooking, upsellConverted: state.upsellBookingReducer.upsellConverted} });
        this.saveAndRedirect(flyback);
        return;
      }

      /**
       * @upsell
       * when both services are available
       * and timeslots for first booking are not available
       * then ask user for upsell booking
       *
       * when timeslots for both services are not available then show the email screen
       */
      if (!timeslotResponse.areTimeSlotsAvailable && availableProducts.abc && availableProducts.ccd) {
        const productAvailability = JSON.parse(JSON.stringify(state.d2dReducer.flightDetails.flightProducts));
        productAvailability[currentBooking] = false;
        this._appStore.dispatch({ type: 'UPDATE_AVAILABLE_PRODUCTS', payload: productAvailability });
        this._appStore.dispatch({ type: 'UPSELL_BOOKING_STATUS', payload: {showUpsellScreen: true, currentBooking: currentBooking, upsellBooking: upsellBooking, upsellConverted: state.upsellBookingReducer.upsellConverted} });
        this._appStore.dispatch({ type: currentBooking === 'abc' ? 'UPDATE_ABC_TIMESLOT_STATUS' : 'UPDATE_CCD_TIMESLOT_STATUS', payload: false });
        this.saveAndRedirect(flyback);

      } else if (!timeslotResponse.areTimeSlotsAvailable) {
        // const errorData = {
        //   text: timeslotResponse.validationErrorMessages[0].reasons[0],
        //   sticky: false
        // };
        // this._errorService.handleCustomError(errorData);
        // this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });

        /**
         * @upsell
         * when only one service is available
         * and timeslots for first booking are not available then show user email screen
         */
        this._appStore.dispatch({ type: 'UPDATE_ABC_TIMESLOT_STATUS', payload: false });
        this._appStore.dispatch({ type: 'UPDATE_CCD_TIMESLOT_STATUS', payload: false });
        this._appStore.dispatch({ type: 'UPSELL_BOOKING_STATUS', payload: {showUpsellScreen: true, currentBooking: currentBooking, upsellBooking: upsellBooking, upsellConverted: state.upsellBookingReducer.upsellConverted} });

        const flightStatusDetails = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightStatusDetails[0];
        exponea.track('noslots_available_flightselection', {
          operated_airline_name: flightStatusDetails.operatingAirlineName,
          marketed_airline_name: flightStatusDetails.airlineName,
          flight_number: flightStatusDetails.flightNumber,
          operated_flight_number: flightStatusDetails.operatingFlightNumber,
          flight_date: flightStatusDetails.departureDateTimeDetails.scheduledDate,
          entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
        })

        this.saveAndRedirect(flyback);
        return;
      } else {
        // timeslots ok
        this._appStore.dispatch({ type: 'SET_REQUEST_COUNT', payload: 0 });
        this.saveAndRedirect(flyback);
      }

    });

  }

  private flightServiceError() {
    this._appLoaderService.hideLoader();
    const errorData = {
      text: "Sorry, we don't service that flight - contact our support team for more info.",
      sticky: false
    };
    this._errorService.handleCustomError(errorData);
    this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
    this._appStore.dispatch({ type: 'UPDATE_DATALINK_ERROR', payload: true });
  }

  getProductType(data) {
    const ccdAvailable = data.productAvailability.ccdAvailable;
    const flightDirection = data.flightDirection;
    console.log('ccd', ccdAvailable, 'direction', flightDirection);
    console.log(ccdAvailable && flightDirection === 2);
    if (ccdAvailable && flightDirection === 2) {
      return [2]
    }
    if (data.productAvailability.abcAvailable === true) {
      return [1]
    }
    return []

  }
  private checkTimeslots(data) {

    console.log(data)
    // const direction based values
    const request: TimeslotAvailability = {
      airline: data.flightStatusDetails[0].airlineCode,
      journeyDirection: data.productAvailability.journeyDirection,
      flightDateTime: '',
      addOnProductType: this.getProductType(data),
      departureAirportCode: '',
      terminal: '',
      destination: data.productAvailability.journeyDirection === 1 ? data.flightStatusDetails[0].arrivalAirport.airportCountryCode : null,
      getBookingPriceRequest: null
    };

    if (data.productAvailability.journeyDirection === 1) {
      request.flightDateTime = data.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal;
      request.departureAirportCode = data.flightStatusDetails[0].departureAirport.airportCode;
      request.terminal = data.flightStatusDetails[0].departureAirport.airportTerminal;
    } else if (data.productAvailability.journeyDirection === 2) {
      request.flightDateTime = data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalDateTimeDetails.scheduledDateTimeLocal;
      request.departureAirportCode = data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalAirport.airportCode;
      request.terminal = data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalAirport.airportTerminal;
    }

    if (this.getState(this._appStore).utilityReducer.isDiamondAirline) {
      request.isDiamondAirBooking = true;
    }

    const promise = new Promise((resolve, reject) => {

      // const headers = new HttpHeaders();
      // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
      const headers = new HttpHeaders()
        .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

      this._http
        .post(API_PATH + TIMESLOT_AVAILABILITY, request, { headers: headers })
        .toPromise()
        .then(
          (res: any) => {
            if (res.validationErrorMessages) {
              const message =  res.validationErrorMessages[0].reasons[0];
              this._errorService.handleCustomError({ text: message, sticky: true });
            }
            resolve(res);
          }
        )
        .catch(
          err => {
            this._errorService.handleError(err);
            this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
            return;
          }
        );
    });
    return promise;

  }

  private saveAndRedirect(flyBack = false) {
    console.log('saveandRedirect');

    if (this._directionChanged) { this._appStore.dispatch({ type: 'RESET_FLIGHT_QUOTE_DATA' }); }
    this._appStore.dispatch({ type: 'RESET_FLIGHT_QUOTE_RESULTS' });

    this._dataStorageService.saveData();
    this._dataSavedSubscription = this._dataStorageService.dataSaved$
      .subscribe(res => {
        const flightData: any = this.getState(this._appStore).flightReducer.flightDetails.flightResponse;
        // redirect once flight data saved
        console.log(flightData, 'fData')
        if (Object.keys(flightData).length > 0) {
          const url = flightData.productAvailability.abcAvailable === true && flightData.productAvailability.journeyDirection === 1 ? 'abc' : 'ccd';
          console.log(url);

          if (this._flightConnectionsSubscription) { this._flightConnectionsSubscription.unsubscribe(); }
          if (this._flightStatsSubscription) { this._flightStatsSubscription.unsubscribe(); }
          // this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
          this._appStore.dispatch({ type: 'UPDATE_SESSION_USED', payload: true });
          this._appStore.dispatch({ type: 'FLIGHT_LOADED', payload: true });
          this._appStore.dispatch({ type: 'UPDATE_API_SEARCH', payload: false });
          this._dataSavedSubscription.unsubscribe();

          const getState = this.getState(this._appStore);
          const bookingState = JSON.parse(JSON.stringify(getState));
          const flightReducer = bookingState.flightReducer;
          const bookingReducer = bookingState.bookingReducer;
          const currentBookingReducer = bookingState.currentBookingReducer;
          const priceReducer = bookingState.priceReducer;
          const timeslotReducer = bookingState.timeslotReducer;
          const flightFinderReducer = bookingState.flightFinderReducer;
          const hubDropReducer = bookingState.hubDropReducer;
          const currentBookingType = bookingState.bookingReducer.bookingDetails.bookingProduct;
          const bookingType = currentBookingType === 'abc' ? 'outboundBooking' : 'inboundBooking'

          this._appStore.dispatch({ type: 'SAVE_BOOKING_DETAILS', payload: { bookingType: bookingType, flightReducer, bookingReducer, currentBookingReducer, priceReducer, timeslotReducer, flightFinderReducer, hubDropReducer, isCompleted: bookingState.d2dReducer[bookingType].isCompleted } });
          this._appStore.dispatch({ type: 'UPDATE_SBB_PUBLIC_TRANSPORT_DISCOUNT_STATUS', payload: false });
          this._appStore.dispatch({ type: 'SBB_SUBSIDY_STATUS_UPDATE', payload: false });
          this._appStore.dispatch({ type: 'RESET_MILES' });

          if(!flyBack){
            setTimeout(() => {
              // check product type
              this._appLoaderService.hideLoader();
              let serviceURL = url === 'abc' ? url + '/collection-location' : url + '/delivery-location';
              this._appStore.dispatch({ type: 'PANEL_SET', payload: 1 });
              this._router.navigate([serviceURL]);
            },);
          } else {
            this._appStore.dispatch({ type: 'UPDATE_CURRENT_STEP' });
            this._dataStorageService.saveData();
          }

        }

      });
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1)).subscribe(s => state = s);
    return state;
  }

}
